// Mirrors analytics/analytics-common/src/event_catalog.rs. The Rust catalog
// is the runtime source of truth; this map keeps frontend call sites
// referencing events by name instead of loose string literals. If you add or
// rename an event in the Rust catalog, update this file — any caller that
// references a removed key fails to typecheck.
export const EVENT = {
  pageview: "pageview",
  identify: "identify",
  heartbeat: "heartbeat",
  signup_started: "signup_started",
  signup_completed: "signup_completed",
  email_verified: "email_verified",
  onboarding_step_viewed: "onboarding_step_viewed",
  onboarding_step_completed: "onboarding_step_completed",
  onboarding_completed: "onboarding_completed",
  integration_connect_clicked: "integration_connect_clicked",
  integration_connected: "integration_connected",
  // Tier 2 — product engagement (only events with no operational-DB equivalent)
  household_opened: "household_opened",
  document_opened: "document_opened",
  meeting_opened: "meeting_opened",
  sidebar_nav_clicked: "sidebar_nav_clicked",
  chat_voice_input_clicked: "chat_voice_input_clicked",
  settings_changed: "settings_changed",
  error_shown: "error_shown",
  auth_logout: "auth_logout",
  // Tier 4 — marketing attribution
  marketing_cta_clicked: "marketing_cta_clicked",
  marketing_nav_clicked: "marketing_nav_clicked",
  marketing_footer_clicked: "marketing_footer_clicked",
  marketing_form_submitted: "marketing_form_submitted",
} as const;

export type EventName = (typeof EVENT)[keyof typeof EVENT];
